// The offer terms, in ONE place, shared by the email and the screen.
//
// ⚠️ THE EMAIL AND THE UI MUST NEVER QUOTE DIFFERENT TERMS. A rep reading "free through March"
// on screen while the customer reads a different date in the mail is the kind of gap that gets
// discovered on a phone call six months later. The server keeps its own copy in
// netlify/functions/lib/vip-winback.js (OFFER) because it enforces rather than displays; if one
// changes, change both. They are asserted equal in scripts/test-vip-winback.js.
//
// Greg, 2026-09-14: "they're gonna renew on April one like they would have before. It's not the
// regular rules where they get the rest of this month and then a full year." So this is a
// reinstatement to the normal club anniversary, not a fresh 12 month term.

export const OFFER_TERMS = {
  price: 0,
  freeThrough: '2027-03-31',
  // ⚠️ US FORMAT, AND ONLY THE LABEL MOVED. Greg wrote "March 31, 2027" and "April 1 2027"
  // into the copy on 2026-09-15; these customers are American and 31 March reads as a date
  // written by somebody else. The ISO values above are what the code compares on and they are
  // untouched, so the test that pins the terms still pins the same terms.
  freeThroughLabel: 'March 31, 2027',
  renewsOn: '2027-04-01',
  renewsOnLabel: 'April 1, 2027',
  // The current single price, live since 2026-08-17. Not the $99.99 these members last paid.
  renewalPrice: 79.99,
};

// The follow-up to a win-back that got no answer, and the date it gives them.
//
// Greg, 2026-10-12: "give them a deadline date. I don't think we gave them a deadline when we
// first emailed them." The server holds the same two dates in
// netlify/functions/lib/vip-winback-followup.js (FOLLOWUP), because it stops the queue on
// lastSendDay. Asserted equal in scripts/test-winback-followup.js.
// One wave per lapse year, each with its own date (2025 added Oct 26, 2024 added Nov 5, 2026). The email takes the
// date from its queue row, which the server fills from the same table.
export const FOLLOWUP_TERMS = {
  waves: {
    2026: { claimBy: '2026-10-30', claimByLabel: 'Friday, October 30', lastSendDay: '2026-10-27' },
    2025: { claimBy: '2026-11-06', claimByLabel: 'Friday, November 6', lastSendDay: '2026-11-03' },
    2024: { claimBy: '2026-11-13', claimByLabel: 'Friday, November 13', lastSendDay: '2026-11-10' },
  },
};
